export const ALL = 'all';
export const FIVE_PLUS = '5+';
export const ONE = '1';

export const BEDROOM_COUNT = ['1', '2', '3', '4', FIVE_PLUS, ALL];
